import React from 'react';
import { Tab as HeadlessTab } from '@headlessui/react';
import { cn } from '../../utils/cn';

export const Tab = React.forwardRef<
  React.ElementRef<typeof HeadlessTab>,
  React.ComponentPropsWithoutRef<typeof HeadlessTab> & {
    className?: string;
  }
>(({ children, className, ...props }, ref) => (
  <HeadlessTab
    ref={ref}
    className={cn(
      // Layout and spacing
      'relative inline-flex items-center justify-center gap-1',

      // Shape and borders. Each tab overlaps the panel's top edge by 1px, so
      // the selected tab can cover that edge and join the panel below.
      'border-container-border -mb-px rounded-t-2xl border',

      // Padding
      'px-16 py-4',

      // Hover state for inactive tabs
      'hover:bg-white dark:hover:bg-gray-800',

      // Accessibility
      'outline-offset-2',

      // Disabled state
      'disabled:cursor-not-allowed disabled:opacity-50',

      // Selected state
      // No bottom border; the fill covers the panel's top edge.
      'data-[selected]:z-10 data-[selected]:border-b-0 data-[selected]:bg-white dark:data-[selected]:bg-gray-800',
      className,
    )}
    {...props}
  >
    {children}
  </HeadlessTab>
));

Tab.displayName = 'Tab';
